import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

/**
 * Hook to get the job search agreement feature flag value for analytics tracking.
 *
 * This is used to include the flag value in Segment events so the data team can
 * identify which HCPs have the hiring agreement feature flag enabled.
 *
 * @returns boolean indicating if the job search agreement feature is enabled for this user
 */
export function useIsJobSearchAgreementEnabled(): boolean {
  return useCbhFlag(CbhFeatureFlag.JOB_SEARCH_AGREEMENT_ENABLED, {
    defaultValue: false,
  });
}
